/**
 * Dropdown Keywords Mapping
 * 
 * Diese Keywords werden automatisch zum User-Prompt hinzugefügt,
 * basierend auf der Dropdown-Auswahl.
 */

// ☀️ TAGESZEIT
export const TIME_OF_DAY_KEYWORDS = {
  'day': 'bright daylight, midday sun, clear daytime lighting',
  'sunrise': 'golden sunrise, warm morning light, dawn glow',
  'sunset': 'golden hour sunset, warm evening light, amber glow',
  'golden_hour': 'golden hour, warm soft light, magical glow',
  'night': 'night time, artificial lighting, evening darkness',
  'blue_hour': 'blue hour twilight, soft purple-blue tones, dusk lighting'
};

// 🌦️ WETTER
export const WEATHER_KEYWORDS = {
  'clear': 'clear weather, bright skies',
  'cloudy': 'cloudy overcast skies, soft diffused light',
  'rain': 'rain falling, wet surfaces, water droplets, rainy atmosphere',
  'storm': 'dramatic storm clouds, heavy rain, intense weather, stormy atmosphere',
  'snow': 'snow falling, winter weather, snowy landscape, cold atmosphere',
  'windy': 'strong wind, dynamic movement, windy conditions',
  'fog': 'foggy atmosphere, mist, reduced visibility, mysterious fog',
  'dust': 'dusty air, sandy atmosphere, dust particles'
};

// 🎥 KAMERA-PERSPEKTIVE
export const CAMERA_KEYWORDS = {
  '24mm': 'shot on 24mm ultra-wide-angle lens, expansive view, environmental context',
  '35mm': 'shot on 35mm wide-angle lens, balanced composition',
  '50mm': 'shot on 50mm lens, natural perspective',
  '85mm': 'shot on 85mm lens, compressed perspective, subject isolation',
  'drone': 'aerial drone shot, bird\'s eye view from above, overhead perspective',
  'top': 'shot from above, high angle, looking down',
  'low': 'shot from below, low angle, looking up, heroic perspective'
};

// 🎨 BILDSTIL
export const STYLE_KEYWORDS = {
  'cinematic': 'volumetric lighting, rim light, anamorphic lens flare, film grain texture, color graded teal and orange, shot on ARRI Alexa or RED camera, Hollywood production quality, epic composition, atmospheric haze, moody lighting',
  'fashion': 'high-fashion photography, editorial pose, studio lighting or natural window light, sharp focus on subject, blurred background, Vogue style, professional fashion shoot, designer clothing implied, confident stance, shot on Hasselblad or Phase One, ultra-high resolution, crisp details',
  'realistic': 'natural lighting, authentic moment, photojournalistic style, candid shot, no artificial effects, documentary approach, shot on Canon or Nikon DSLR, real-world colors, unfiltered, genuine expression, everyday scene',
  'action': 'explosive motion blur, dynamic composition, high shutter speed frozen action, dramatic movement, intense energy, sports photography style, peak action moment, adrenaline, shot on high-speed camera, ultra-sharp subject, motion trails',
  'documentary': 'photojournalistic style, candid moment, natural available light, no staging, authentic real-life scene, observational, National Geographic quality, story-driven composition, shot on Leica or documentary camera, raw unfiltered reality',
  'street': 'urban grit, raw city energy, street photography style, decisive moment, available city light, neon reflections, authentic urban atmosphere, shot on Fujifilm or rangefinder, high contrast, bold shadows, gritty realistic textures',
  'nature': 'natural outdoor lighting, golden hour, adventure photography, exploration moment, environmental context, wilderness, National Geographic expedition style, dramatic landscape integration, shot on outdoor camera gear, vibrant natural colors, crisp air'
};

// 🖼️ BILDFORMAT (Labels für UI)
export const IMAGE_FORMAT_LABELS = {
  'portrait_9_16': 'Hochformat 9:16 (Instagram Story)',
  'landscape_16_9': 'Querformat 16:9 (Standard)',
  'square': 'Quadrat 1:1 (Instagram Post)'
};

/**
 * Gibt die Keywords für einen Dropdown-Wert zurück
 */
export function getKeywordsForValue(category, value) {
  switch(category) {
    case 'timeOfDay':
      return TIME_OF_DAY_KEYWORDS[value] || '';
    case 'weather':
      return WEATHER_KEYWORDS[value] || '';
    case 'camera':
      return CAMERA_KEYWORDS[value] || '';
    case 'style':
      return STYLE_KEYWORDS[value] || '';
    default:
      return '';
  }
}

/**
 * Gibt ein User-freundliches Label für einen Dropdown-Wert zurück
 */
export function getLabelForValue(category, value) {
  const labels = {
    timeOfDay: {
      'day': 'Tag',
      'sunrise': 'Sonnenaufgang',
      'sunset': 'Sonnenuntergang',
      'golden_hour': 'Golden Hour',
      'night': 'Nacht',
      'blue_hour': 'Blaue Stunde'
    },
    weather: {
      'clear': 'Klar',
      'cloudy': 'Bewölkt',
      'rain': 'Regen',
      'storm': 'Gewitter',
      'snow': 'Schnee',
      'windy': 'Windig',
      'fog': 'Nebel',
      'dust': 'Staubig'
    },
    camera: {
      '24mm': '24mm Weitwinkel',
      '35mm': '35mm Standard',
      '50mm': '50mm Natur',
      '85mm': '85mm Portrait',
      'drone': 'Drohne (von oben)',
      'top': 'Von oben',
      'low': 'Von unten'
    },
    style: {
      'cinematic': 'Filmisch',
      'fashion': 'Fashion',
      'realistic': 'Realistisch',
      'action': 'Action',
      'documentary': 'Dokumentarisch',
      'street': 'Street',
      'nature': 'Natur'
    },
    imageFormat: IMAGE_FORMAT_LABELS
  };
  
  return labels[category]?.[value] || value;
}
